/**
 * krypton API
 * Documentation of API endpoints of krypton
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { GenerateReportsCreate400ResponseErrorsInner } from '../models/GenerateReportsCreate400ResponseErrorsInner';
import { HttpFile } from '../http/http';

export class GenerateReportsCreate400Response {
    'type'?: string;
    'errors'?: Array<GenerateReportsCreate400ResponseErrorsInner>;

    static readonly discriminator: string | undefined = undefined;

    static readonly mapping: {[index: string]: string} | undefined = undefined;

    static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
        {
            "name": "type",
            "baseName": "type",
            "type": "string",
            "format": ""
        },
        {
            "name": "errors",
            "baseName": "errors",
            "type": "Array<GenerateReportsCreate400ResponseErrorsInner>",
            "format": ""
        }    ];

    static getAttributeTypeMap() {
        return GenerateReportsCreate400Response.attributeTypeMap;
    }

    public constructor() {
    }
}
